export function assumeInitialized<T>(): T {
    return (undefined as unknown as T);
}
